// Formats a date string using Intl.DateTimeFormat if it's a valid date, otherwise returns the value unchanged.
export default function useFormatDate(
  value: string,
  locale: string = 'de-CH',
  options: Intl.DateTimeFormatOptions = {
    year: 'numeric',
    month: 'numeric',
    day: 'numeric',
  },
): string {
  // Return original value if input is empty, not a string, or too short
  if (!value || typeof value !== 'string' || value.length < 5) {
    return value
  }

  // Common date format regex (e.g., YYYY-MM-DD, MM/DD/YYYY, DD.MM.YYYY, ISO)
  const dateRegex = /^(?:\d{4}-\d{2}-\d{2}(?:T\d{2}:\d{2}:\d{2}(?:\.\d+)?(?:Z|[+-]\d{2}:\d{2})?)?|\d{2}[./-]\d{2}[./-]\d{4}|\d{4}[./-]\d{2}[./-]\d{2})$/

  // Check if the string matches a common date format
  if (!dateRegex.test(value)) {
    return value
  }

  try {
    const dateObj = new Date(value)

    // Check if the date is valid
    if (isNaN(dateObj.getTime())) {
      return value
    }

    return dateObj.toLocaleDateString(locale, options)
  } catch (error) {
    console.warn('Error formatting date:', error)
    return value
  }
}
